import ContactsBlock from "components/Contacts/ContactsBlock"

const ContactsPage = () => {
    return (
        <ContactsBlock />
    )
}

export default ContactsPage